<template>
    <div class="config-recommended">
        <BasicTitle title="初步配置推荐"></BasicTitle>
        <!--       内容     -->
        <div class="entity">
            <div class="config-item" @click="selectConfig(item)" v-for="item in arrRecommended" :key="item.key">{{ item.name }}</div>
        </div>


        <!--     配置设备弹窗     -->
        <VantPopup :close-on-click-overlay="false" closeable v-model="bRecShowVisible" class="config-submit-wrap " @close="resetConfigChose">
            <MachineConfigView v-if="bRecShowVisible" class="config-submit-content" :selectRecommend="objSelectRecommendSelf" @commitRecommend="selectConfig"></MachineConfigView>
        </VantPopup>

        <!--    安装设备选择弹窗    -->
        <VantPopup v-model="bSelectMachineVisible" class="select-machine-content">
            <div class="select-title">请选择您要安装的设备配置 （可多选）</div>
            <!--      选择容器        -->
            <div class="chose-container">
                <div class="chose-item" :class="{'chose-item-active': item.select}" @click="item.select = !item.select" v-for="item in recommendOneList" :key="item.btnKey">
                    <div class="name">{{ item.name }}</div>
                    <img :src="require('@/assets/images/hvac/mapping/finish-icon.png')" class="icon" alt="">
                </div>
            </div>
            <!--      按钮      -->
            <div class="button-content">
                <div class="item cancer" @click="changeSelectMachineVisible">返回</div>
                <div class="item" @click="confirmMach">确认</div>
            </div>
        </VantPopup>

        <p class="tips">根据实际情况需求选择</p>
    </div>
</template>

<script>
import BasicTitle from './basictitle';
import MachineConfigView from './machineconfigview'
import {Popup} from 'vant';
import {mapState} from "vuex";

export default {
    name: "configRecommend",
    data() {
        return {
            // 配置设备弹窗显示控制
            bRecShowVisible: false,
            // 当前选择的配置项，是配置推荐渲染其元素
            objSelectRecommendSelf: {},
            // 安装设备选择弹窗
            bSelectMachineVisible: false,
        }
    },
    components: {
        BasicTitle,
        VantPopup: Popup,
        MachineConfigView,
    },
    computed: {

        ...mapState({
            // 配置推荐渲染
            arrRecommended: state => state.hvacMappingEntry.arrRecommended,
        }),
        // 当前选择的配置项的多选项
        recommendOneList() {
            return this.objSelectRecommendSelf.popupConfig?.choseBtn.find(i => i.type === 'double').children;
        }
    },
    methods: {
        /**
         * 选择配置推荐
         * @param item
         */
        selectConfig(item = {}) {
            if (item.needChose) {
                // 如果需要选择配置
                this.changeSelectMachineVisible();
            } else {
                this.changeRecShowVisible();
            }

            this.objSelectRecommendSelf = item;
        },
        /**
         * 配置选择确认
         */
        confirmMach() {
            this.changeSelectMachineVisible();
            this.changeRecShowVisible();
        },
        /**
         * 改变配置选择弹窗显示
         */
        changeSelectMachineVisible() {
            this.bSelectMachineVisible = !this.bSelectMachineVisible;
        },
        /**
         * 改变配置设备弹窗显示
         */
        changeRecShowVisible() {
            this.bRecShowVisible = !this.bRecShowVisible;
        },
        /**
         * 配置设备弹窗关闭
         */
        resetConfigChose() {
            this.objSelectRecommendSelf = {};
        },
    }
}
</script>

<style scoped lang="scss">
.config-recommended {
    padding: 32px 24px 24px;
    border-radius: $commonRadius;
    background: #FFFFFF;
    margin-bottom: 24px;


    .entity {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        padding-top: 28px;

        .config-item {
            flex: 0 0 316px;
            height: 80px;
            border-radius: $commonRadius;
            background: #F7F7F7;
            line-height: 80px;
            text-align: center;
            margin-bottom: 20px;
            transition: all 0.5s;

            &:last-of-type {
                margin-bottom: 0;
                flex: 0 0 100%;
            }
        }

    }


    .config-submit-wrap {
        width: 100vw;
        height: 100vh;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(#FFFFFF, 0);

        .config-submit-content {
            width: 704px;
            max-height: 86vh;
            min-height: 674px;
            background: #FFFFFF;
            border-radius: $commonRadius;
            overflow-y: auto;
            padding: 32px 24px 30px;
            left: 0;
            top: 0;
        }

    }

    .tips {

        line-height: 34px;
        height: 34px;
        margin-top: 16px;
        text-align: center;
        color: #A2A2A2;
        font-size: $smallSize;
    }

    .select-machine-content {
        width: 598px;
        //height: 678px;
        padding: 32px 28px 52px;
        background: #FFFFFF;
        border-radius: $commonRadius;

        .select-title {
            line-height: 44px;
            width: 390px;
            text-align: center;
            margin: 0 auto 40px;
            font-size: $bigSize;
            font-weight: 500;
        }

        .chose-container {
            margin-bottom: 86px;

            .chose-item {
                font-size: $bigSize;
                height: 80px;
                border: 1px solid #C4C4C4;
                border-radius: 80px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 28px;

                padding: 0 32px;

                &:last-of-type {
                    margin-bottom: 0;
                }

                .icon {
                    display: none;
                }
            }

            .chose-item-active {
                color: $deepGreen;
                border-color: $deepGreen;

                .icon {
                    display: block;
                    width: 40px;
                    height: 40px;
                }
            }
        }

        .button-content {
            display: flex;
            align-items: center;
            justify-content: space-between;


            .item {
                flex: 0 0 260px;
                height: 80px;
                background: $deepGreen;
                color: #FFFFFF;
                text-align: center;
                line-height: 80px;
                border-radius: $commonRadius;
            }

            .cancer {
                background: #EBEBEB;
            }
        }
    }
}

</style>